import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { COL, type ArtistReferral } from '@eprintsmart/shared';
import { db } from '../firebase';

/** Artist-to-artist referrals, from the staff side. */

const fns = () => getFunctions(undefined, 'asia-south1');

export function watchArtistReferrals(
  cb: (rows: ArtistReferral[]) => void,
  max = 200,
): () => void {
  return onSnapshot(
    query(collection(db, COL.artistReferrals), orderBy('createdAt', 'desc'), limit(max)),
    (snap) => cb(snap.docs.map((d) => ({ ...(d.data() as ArtistReferral), id: d.id }))),
  );
}

/**
 * Marks a confirmed referral paid.
 *
 * Idempotent at the callable, which matters more than it looks: this is a table
 * with a button per row and two people can be looking at it. The function
 * re-reads the status inside a transaction and returns `paid: false` rather
 * than throwing when it was already done.
 */
export async function payArtistReferral(referralId: string): Promise<{ paid: boolean }> {
  const call = httpsCallable<{ referralId: string }, { paid: boolean }>(
    fns(), 'payArtistReferral',
  );
  return (await call({ referralId })).data;
}
